import axios from "axios"
import {API_URL_DEV, API_URL_PRODUCTION} from "../Const"

export const getApiUrl = () => {

    try {
        /*
        if (process.env.REACT_APP_API_URL_TARGET) {
            return process.env.REACT_APP_API_URL_TARGET;
        }
         */
        if (process.env.NODE_ENV === 'production') {
            return getLiveApiUrl();
        }
    } catch (error) {

    }

    return API_URL_DEV

};

export const getLiveApiUrl = () => {
    return API_URL_PRODUCTION;
}


let instance = axios.create({
    baseURL: getApiUrl(),
    responseType: "json",
});

// request header
instance.interceptors.request.use((config) => {
    return config
}, error => {
    return Promise.reject(error)
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if (error.response && error.response.status === 500) {
        let root = document.getElementById('root');
        if (root) {
            let notification = document.createElement('div');
            notification.addEventListener('click', () => {
                root.removeChild(notification);
            });
            notification.innerHTML = '<div class="error-notification"><div class="error-notification-inner"><table><tr><td>Es ist ein unerwarteter Fehler aufgetreten.<br>Dieser Fehler wurde automatisch an weitergeleitet.<br><i>' + (error.response.statusText || 'Unknown error') + '</i><br><br><button class="btn btn-primary">Schließen</button></td></tr></table></div></div>';
            root.appendChild(notification);
        }
    }

    console.error('API Error:', error);
    return Promise.reject(error);
});


// Function to get member images using the new API method
export const getMemberImage = async (parentId, parentTable = 'member', imageTitle) => {
    if (!parentId || !imageTitle) {
        return null;
    }

    try {
        const response = await instance.get(`open/image`, {
            params: {
                image_parent_id: parentId,
                image_parent_table: parentTable,
                image_title: imageTitle
            }
        });

        if (response.data &&
            response.data.status === "success" &&
            response.data.items &&
            response.data.items.length > 0) {

            const imageData = response.data.items[0];

            // Use the imageout endpoint with proper sizing
            if (imageData.image_id) {
                const size = imageTitle === 'logo' ? '400' : '1920';
                const height = imageTitle === 'logo' ? '400' : '600';
                
                // Add cache busting parameter if image has been recently modified
                let cacheParam = '';
                if (imageData.image_modified) {
                    const modifiedTime = new Date(imageData.image_modified).getTime();
                    cacheParam = `&t=${modifiedTime}`;
                } else if (imageData.image_created) {
                    const createdTime = new Date(imageData.image_created).getTime();
                    cacheParam = `&t=${createdTime}`;
                }
                
                return `${getApiUrl()}imageout/${imageData.image_id}?width=${size}&height=${height}&quality=85${cacheParam}`;
            }
        }

        return null;
    } catch (error) {
        // If the request fails, try using a direct fallback URL
        if (error.response && error.response.status === 404) {
            console.warn(`Image not found for ${imageTitle} of member ${parentId}, using fallback`);
            // Return a fallback image URL
            const fallbackType = imageTitle === 'logo' ? 'lfallback.jpg' : 'fallback.jpg';
            const size = imageTitle === 'logo' ? '400' : '1920';
            const height = imageTitle === 'logo' ? '400' : '600';
            return `${getApiUrl()}imageout/null/${fallbackType}?width=${size}&height=${height}`;
        }
        console.error(`Error fetching ${imageTitle} image for member ${parentId}:`, error.message);
        return null;
    }
};

export default instance;
